// @ts-check
/* ═══════════════════════ QR-KODE (#9) ═══════════════════════
   Lager en EKTE, skannbar QR-kode for delingslenker. Den gamle
   canvas-«QR»-en var bare et dekorativt mønster og kunne ikke
   skannes — her bruker vi en faktisk QR-renderer.

   Deling er en online-handling (du sender en lenke), så vi henter
   en garantert korrekt QR fra et bilde-endepunkt. Faller lenken
   ut (offline), skjuler vi bildet og lar den synlige URL-en stå —
   som uansett er det familien trenger.
   ═══════════════════════════════════════════════════════════════ */

/**
 * Returnerer et <img>-element med en skannbar QR-kode for `text`.
 * @param {string} text
 * @param {number} size  pikselstørrelse (kvadrat)
 * @returns {HTMLImageElement}
 */
export function makeQR(text, size = 180){
  const img = document.createElement('img');
  img.width = size; img.height = size;
  img.alt = 'QR-kode';
  img.loading = 'eager';
  img.decoding = 'async';
  img.style.cssText = `width:${size}px;height:${size}px;background:#fff;padding:8px;box-sizing:border-box`;
  const enc = encodeURIComponent(text);
  img.src = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=0&data=${enc}`;
  img.onerror = () => { img.style.display = 'none'; };
  return img;
}
